<template>
    <section class="policy-wrapper flow__panel">
        <h2 class="policy-wrapper__title">
            {{ title }}
        </h2>
        <component :is="policy"
                   :is-direct="true"
                   class="policy-wrapper__policy" />
    </section>
</template>

<script>

export default {

    props: {
        policy: {
            type: Object,
            required: true,
        },
        title: {
            type: String,
            required: true,
        },
    },
}

</script>

<style lang="scss">

.policy-wrapper {
    margin-top: -3rem;

    @include bp-min-small {
        margin-top: -1rem;
    }

    @include bp-min-mid {
        margin-top: -1.5rem;
    }

    @include bp-min-wide {
        margin-top: 0.5rem;
    }
}

</style>
